// ============================================================================
// @gs/i18n/supportedLocales — vocabulaire de langue, ZERO dependance
// ============================================================================
// Ce module n'importe RIEN (ni React, ni i18next). Il existe pour que le point
// d'entree SANS React (`core.ts`, D10) puisse nommer une locale sans tirer le
// contexte React de `localeContext.ts` — un serveur Express n'a pas de React.
// `localeContext.ts` re-exporte ces trois symboles : l'API publique du
// sous-chemin '@gs/i18n/localeContext' (consomme par @gs/ui) ne change pas.

export type SupportedLocale = 'fr' | 'en';

/** Fallback TOUJOURS FR (marche primaire Quebec) — I18N_STANDARDS. */
export const DEFAULT_LOCALE: SupportedLocale = 'fr';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['fr', 'en'];
